<div style="display: flex; flex-flow: column; height: 100%;">
  <mat-toolbar color="primary" class="fixed-toolbar">
    <div *ngIf="loginStatus">
      <button mat-icon-button  class="menu-btn" (click)="isMenuExpanded = !isMenuExpanded" >
        <mat-icon class="black-icon fixed-icon">menu</mat-icon>
      </button>
    </div>
    <div style="margin-top: 5px;margin-bottom: 5px;">
      <img style="height: 60px; float: left; margin-left: 15px; margin-right: 10px;" src="../assets/images/Refinery Icon Maroon.png" />
      <div class="transformersfont">
        <span class="csdata">Data </span><span class="cstrans">Trans</span><span class="csfor">form</span><span class="csrefinery"> Refinery</span>
      </div>
    </div>

    <div style="color: #000000;" fxFlex fxLayoutAlign="flex-end center">
      <div>
        <span style="margin-right: 20px; font-size: 10pt; color: #063d71; font-weight: 500;">{{orgname}}</span>
        <span style="margin-right: 0px; font-size: 10pt; color: #063d71; font-weight: 500;">{{welcomeText}}</span>
          <span style="color:#fff;margin-left:3px; font-weight: 500; font-size: 10pt;margin-right:10px; ">{{userFullName}}</span>
        <mat-slide-toggle style="margin-right: 30px; font-size: 10pt; color: #fff; font-weight: 500;" [checked]="isDarkMode" (change)="toggleDarkTheme($event)">Compact Layout</mat-slide-toggle>
      </div>
      <div style="margin-right: 20px;">
        <div style="color: grey; font-weight: medium; font-size: 10px; margin-top: -10px;">Version: <span style="color: white;">{{ version }}</span></div>
        <div style="color: grey; font-weight: medium; font-size: 10px; margin-top: -15px;">Build: <span style="color: white;">{{ build }}</span></div>
        
      </div>
      <div>
        <div style="margin-top: 10px;">
          <img src="../assets/images/Evidant Logo Dark.png" style="width: 115px;" />
        </div>
        <div style="color: grey; font-weight: medium; font-size: 10px; margin-top: -10px;">
          Engine: <span style="color: white;">{{ environmentService.activeEngineEndpointName }}</span>
          <span style="margin-left: 5px;">App: <span style="color: white;">{{ environmentService.activeAppEndpointName }}</span></span>
        </div>
      </div>
    </div>
  </mat-toolbar>

  <mat-drawer-container autosize style="height: 100%;">
    <mat-drawer #drawer mode="side" disableClose="true" opened="true" >
      <mat-nav-list fxLayout="column" fxFill>

        <!-- Other menu options based on loginStatus -->
        <ng-container *ngIf="loginStatus">
   
          <!-- <a mat-list-item  title="Refinery" (click)="warningUser()" >
            <mat-icon class="icon">table_chart</mat-icon>
            <span class="label" *ngIf="isMenuExpanded">Refinery</span>
          </a>
          <a mat-list-item routerLink="/configs" title="Pipelines" >
            <mat-icon class="icon">build</mat-icon>
            <span class="label" *ngIf="isMenuExpanded">Pipelines</span>
          </a>
          <a mat-list-item routerLink="/scheduler" title="Schedule" >
            <mat-icon class="icon">alarm</mat-icon>
            <span class="label" *ngIf="isMenuExpanded">Scheduler</span>
          </a>
       
          <a mat-list-item routerLink="/devData" title="Development Data" >
            <mat-icon class="icon">upload_file</mat-icon>
            <span class="label" *ngIf="isMenuExpanded">Development Data</span>
          </a> -->
          <a mat-list-item title="Refinery" (click)="warningUser()" [class.nav-disabled]="runInProgress">
  <mat-icon class="icon">table_chart</mat-icon>
  <span class="label" *ngIf="isMenuExpanded">Refinery</span>
</a>

<!-- <a mat-list-item routerLink="/configs" title="Pipelines" [class.nav-disabled]="runInProgress">
  <mat-icon class="icon">build</mat-icon>
  <span class="label" *ngIf="isMenuExpanded">Pipelines</span>
</a> -->

<a mat-list-item routerLink="/scheduler" title="Schedule" [class.nav-disabled]="runInProgress">
  <mat-icon class="icon">alarm</mat-icon>
  <span class="label" *ngIf="isMenuExpanded">Scheduler</span>
</a>

<a mat-list-item routerLink="/devData" title="Development Data" [class.nav-disabled]="runInProgress">
  <mat-icon class="icon">upload_file</mat-icon>
  <span class="label" *ngIf="isMenuExpanded">Development Data</span>
</a>

        </ng-container>

        <!-- Settings option always visible -->
        <a mat-list-item routerLink="/settings" title="Settings"  [class.nav-disabled]="runInProgress">
          <mat-icon class="icon">settings</mat-icon>
          <span class="label" *ngIf="isMenuExpanded">Settings</span>
        </a>

        <!-- Login option visible only when not logged in -->
        <a mat-list-item *ngIf="!loginStatus" routerLink="/sign-in" title="sign in" >
          <mat-icon class="icon">login</mat-icon>
          <span class="label" *ngIf="isMenuExpanded">Signin</span>
        </a>

        <ng-container *ngIf="loginStatus">
          <a mat-list-item routerLink="/errorLog" title="Error Log" [class.nav-disabled]="runInProgress">
            <mat-icon class="icon">error</mat-icon>
            <span class="label" *ngIf="isMenuExpanded">Error Log</span>
          </a>
        </ng-container>

        <span fxFlex></span>

        <ng-container *ngIf="loginStatus">
          <a mat-list-item (click)="logout()" title="Sign out">
            <mat-icon class="icon">exit_to_app</mat-icon>
            <span class="label" *ngIf="isMenuExpanded">Sign out</span>
          </a>
        </ng-container>
      </mat-nav-list>
    </mat-drawer>

    <div class="example-sidenav-content" style="margin-top: 60px;">
      <main>
        <div [@routeAnimations]="prepareRoute(outlet)">
          <router-outlet #outlet=outlet></router-outlet>
        </div>
      </main>
    </div>

    <mat-drawer (openedChange)="onSideBarOpenedChange($event)" style="margin-right: 0px" #sidebarDrawer mode="over" position="end" opened="false">
      <div style="width: 800px; background-color: #000000">
        <router-outlet name="sidebar"></router-outlet>
      </div>
    </mat-drawer>
  </mat-drawer-container>

  <!-- DTR Copilot — outside the route animation container so position:fixed works correctly -->
  <app-copilot-panel
    *ngIf="copilotContext"
    [transformType]="copilotContext.transformType"
    [transformId]="copilotContext.transformId"
    [refineryId]="copilotContext.refineryId"
    [transformLabel]="copilotContext.transformLabel"
    [transformName]="copilotContext.transformName"
    [currentConfig]="copilotContext.currentConfig"
    [columnNames]="copilotContext.columnNames"
    [constraints]="copilotContext.constraints"
    [inputCacheKey]="copilotContext.inputCacheKey || ''"
    [lastRunStats]="copilotContext.lastRunStats || {}"
    (configReplaceRequested)="copilotCtx.emitConfigReplace($event, copilotContext.transformId)"
    (configMergeRequested)="copilotCtx.emitConfigMerge($event, copilotContext.transformId)"
    (configPreviewUpdate)="copilotCtx.emitConfigPreview($event.config, copilotContext.transformId, $event.skipRun)"
    (analysisPreviewUpdate)="copilotCtx.emitAnalysisPreview($event)"
    (runAuditRequested)="copilotCtx.emitRunAudit()">
  </app-copilot-panel>

</div>
